import React, { useEffect, useState } from 'react';
import useStateRef from "react-usestateref";
import { useNavigate } from 'react-router-dom';
import EventEmitter from 'src/utils/EventEmitter';
import Page from 'src/components/Page';
import './index.css';
import { LoadingView } from 'src/components/LoadingView';
// import axios from 'axios';

const PrivacyPolicyPublicPage = () => {
  /* eslint-disable */
  const navigate = useNavigate();
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading, loadingRef] = useStateRef(false);
  const [content, setContent, contentRef] = useStateRef("");
  /* eslint-enable */

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const onClickPrevStep = () => {
      onClickBackArrow();
    }

    const listener = EventEmitter.addListener('prev_step', onClickPrevStep);

    return () => {
      listener.remove();
    }
  }, []);

  useEffect(() => {
    if (!initialized) {
      setInitialized(true);
      // setLoading(true);
      // getData();
    }
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  // const getData = async () => {
  //   try {
  //     var hostname = window.location.origin;

  //     if (hostname) {
  //       if (hostname.includes("localhost")) {
  //         hostname = "cannatrek-patient.dynamicweb.net.au";
  //       }
  //     }

  //     await axios.get(`/dwapi/content/pages/url?url=/myeden/privacy-policy&hostname=${hostname}`, {
  //     }, {})
  //       .then(async response => {
  //         if (response) {
  //           if (response.data) {
  //             if (response.data.Item) {
  //               if (response.data.Item.Fields) {
  //                 var fields = response.data.Item.Fields;
  //                 fields.map((value) => {
  //                   if (value.Name === "Content") {
  //                     var new_content = value.Value.replace("{window.location.origin}", window.location.origin);
  //                     setContent(new_content);
  //                   }
  //                 })
  //               }
  //             }
  //           }
  //         }
  //       })
  //   } catch (e) {

  //   }
  //   setLoading(false);
  // }

  const onClickBackArrow = () => {
    navigate('/profile');
    EventEmitter.emit("show_full", { value: false });
    EventEmitter.emit("show_top_navigation", { value: false });
  }

  return (
    <Page title="Privacy Policy" style={{ height: "100%" }} className="main-layout main-layout-public">
      {loadingRef.current ?
        <LoadingView />
        :
        <div className="main-wrapper-3">
          <div className="main-wrapper-padding">
            <div className="top-wrapper-title-2">Privacy Policy for greenship pharmacy</div>
            <div className="main-wrapper-content-description">
              <div className="terms_and_conditions_container">
                <div dangerouslySetInnerHTML={{ __html: contentRef.current }} />
              </div>
            </div>
          </div>
        </div>
      }
    </Page >
  )
}

export default PrivacyPolicyPublicPage;